import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa";
import { CircularProgress } from "@mui/material";
import tw from "tailwind-styled-components";
import { Label, ModalHeader, ScrollableContent } from "../Styles/InputStyles";
import { GoSearch } from "react-icons/go";

const SelectCategoryModal = ({
    isOpen,
    onClose,
    title = "Select Option",
    options = [],
    selectedValues = [],
    onSelect,
    onApply,
    isLoading = false,
    closeOnSelect = false,
    searchPlaceholder = "Search...",
}) => {

    const [searchText, setSearchText] = useState("");

    if (!isOpen) return null;

    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchText.toLowerCase())
    );

    const isSelected = (value) => {
        return selectedValues?.some(
            (item) => item.value === value
        );
    };

    const handleSelect = (option) => {

        let updatedValues = [];

        if (isSelected(option.value)) {
            // remove item
            updatedValues = selectedValues.filter(
                (item) => item.value !== option.value
            );
        } else {
            // add item
            updatedValues = [...selectedValues, option];
        }

        onSelect(updatedValues);

        if (closeOnSelect) {
            onClose();
        }
    };

    return (
        <Overlay>
            <ModalWrapper>

                <ModalHeader>
                    <h1 className="text-white text-lg font-medium">
                        {title}
                    </h1>

                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>

                <div className="px-4 pt-4 relative">
                    <div className="relative">

                        <input
                            type="text"
                            placeholder={searchPlaceholder}
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300"
                        />

                        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                            <GoSearch className="w-4 h-4 text-gray-400" />
                        </div>

                    </div>
                </div>

                <ScrollableContent className="max-h-[calc(100dvh-140px)]">

                    {isLoading ? (
                        <div className="flex justify-center py-8">
                            <CircularProgress />
                        </div>
                    ) : filteredOptions.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            No options found
                        </div>
                    ) : (
                        filteredOptions.map((option) => (

                            <OptionRow
                                key={option.value}
                                onClick={() =>
                                    !option.disabled && handleSelect(option)
                                }
                            >

                                <Label className={option.disabled ? "text-gray-400" : ""}>
                                    {option.label}
                                </Label>

                                <button
                                    disabled={option.disabled || isLoading}
                                    className={option.disabled ? "cursor-not-allowed" : ""}
                                >

                                    {isLoading ? (
                                        <CircularProgress size={20} />
                                    ) : isSelected(option.value) ? (
                                        <FaRegCheckSquare
                                            size={20}
                                            className="text-primary-color"
                                        />
                                    ) : (
                                        <FaRegSquare
                                            size={20}
                                            className="text-gray-300"
                                        />
                                    )}

                                </button>

                            </OptionRow>

                        ))
                    )}

                </ScrollableContent>
                <div className="p-4 border-t border-gray-100">
                    <button
                        onClick={() => {
                            onApply?.(selectedValues);
                            onClose();
                        }}
                        disabled={selectedValues.length === 0}
                        className={`
                                w-full h-12 rounded-lg text-white font-medium transition-all
                                ${selectedValues.length === 0
                                ? "bg-gray-300 cursor-not-allowed"
                                : "bg-primary-color hover:opacity-90"}
                        `}
                    >
                        {selectedValues.length > 0
                            ? `Apply (${selectedValues.length})`
                            : "Select Options"}
                    </button>
                </div>

            </ModalWrapper>
        </Overlay>
    );
};

const Overlay = tw.div`
fixed inset-0 z-50 flex items-center justify-end bg-black/50
`;

const ModalWrapper = tw.div`
bg-white w-11/12 h-full flex flex-col relative
`;

const OptionRow = tw.div`
ml-2 flex items-center justify-between p-4 border-b border-gray-100 cursor-pointer hover:bg-gray-50
`;

export default SelectCategoryModal;